import { render, staticRenderFns } from "./OnlineSwitch.vue?vue&type=template&id=871fd5e0"
import script from "./OnlineSwitch.vue?vue&type=script&lang=ts"
export * from "./OnlineSwitch.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports